export default "__VITE_ASSET__DUOXobOE__"